import { IDoctor } from "../../../../dto/interfaces";
import makeRequest from "../../../makeRequest";

const url = "/api/user/";


export async function getDoctorInfoByAlias(alias: string, headers?: Record<string, string>): Promise<IDoctor> {
    return makeRequest("GET", url + `doctor/${alias}`, {}, headers);
}

export async function getAllDoctors(headers?: Record<string, string>): Promise<IDoctor[]> {
    return makeRequest("GET", url + "doctors/list", {}, headers);
}
